import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TslSelect } from '@tesla/ng-tds';
import { SupplierTaskEntityMapping, SupplierTaskEntityMappingOption } from 'app/profile/models/suppliertasks.model';
import { I18nService } from 'app/shared/services/i18n.service';

@Component({
  selector: 'app-entity-mapping',
  templateUrl: './entity-mapping.component.html',
  styleUrls: ['./entity-mapping.component.scss']
})
export class EntityMappingComponent implements OnInit {
  @ViewChildren("selectFields") selectFields: QueryList<TslSelect>;
  @Input("masterData") set _masterData(value: SupplierTaskEntityMapping[]) {
    this.masterData = value;
    this.dataSource.data = this.masterData;
  };
  @Input("options") set _options(value: SupplierTaskEntityMappingOption[]) {
    this.options = value;
    this.masterData?.forEach(x => {
      if(x.taskItem) {
        if(!this.getOptions(x.entityCountryName)?.find(y => y.value == x.taskItem)) x.taskItem = null;
      }
    });
  };
  @Input() itemType: string = "Item";
  @Input() errorMessage: string = "Please provide item to all entity countries.";
  @Output() onSubmitEmitter: EventEmitter<SupplierTaskEntityMapping[]> = new EventEmitter<SupplierTaskEntityMapping[]>();
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['entityCountry', 'item'];
  masterData: SupplierTaskEntityMapping[];
  options: SupplierTaskEntityMappingOption[];
  showErrorMessage: boolean = false;

  constructor(
    public translate: I18nService,
  ) { }

  ngOnInit(): void { }

  onSelectChange() {
    this.showErrorMessage = false;
  }

  onSubmit() {
    if(this.masterData?.find(x => !x.taskItem)) {
      this.showErrorMessage = true;
      this.selectFields.map(x => x._onTouched())
      return null;
    }
    this.onSubmitEmitter.emit(this.masterData);
    return this.masterData;
  }

  getOptions(country): SupplierTaskEntityMappingOption[] {
    if(this.itemType == "Bank") return this.options?.filter(x => {
      if(!x.info?.PaymentOrigin || (x.info?.PaymentOrigin == "Domestic" && x.info?.CountryName != country)) return false;
      return true;
    })
    return this.options;
  }
}
